<template>
  <PageContent>
    <StepsV2 :step="4"/>
    <PanelV2
      type="w6"
      title="Provide a photo of your physical store"
      mode="submit"
      @nextClick="commitData()"
    >
      <template v-slot:title-solt>
        <BdoProgress  :step="2" :total="2" />
      </template>
      <template v-slot:content-solt>
        <IdCardUpload photoType="store" @exteriorImg="exteriorImg" @interiorImg="interiorImg" :photoData="formData" />
      </template>
    </PanelV2>
  </PageContent>
</template>

<script>
  // import AppForm from "../forms/ExistingBDOMerchant.val";
  import IdCardUpload from "../pages/common/IdCardUpload.vue";
  import API from "@/api";

  export default {
    name: 'IndividualK',
    pRouter: 'IndividualJ',
    components: {
      // AppForm,
      IdCardUpload,
    },
    data() {
      return {
        formData: {
          interior: [],
          exterior: [],
        },
        formData2: {
          interior: [],
          exterior: [],
        }
      }
    },
    methods: {
      exteriorImg(val){
        this.formData2.exterior = val;
      },
      interiorImg(val){
        this.formData2.interior = val;
      },
      commitData() {
        const { interior, exterior } = this.formData2;
        if ((interior.length > 0) && (exterior.length > 0)) {
          const data = this.formatCommitData({...this.formData2})

          API.addBdoProcess({
            ...data
          }).then(res => {
            if (res.success) {
              this.toNext()
            }
          })
        } else {
          this.showMessageTip('Upload photo of your store')
        }
      }
    }
  }
</script>


<style lang="scss" scoped>

</style>
